<template>
  <div class="industry">
    <Banner :url="config?.background_image_url" :desc="config?.guiding_text">
      <template #breadcrumb>
        <a-breadcrumb :separator="separator">
          <a-breadcrumb-item>
            <nuxt-link :to="homeRoute">
              {{ $t('shou-ye') }}
            </nuxt-link>
          </a-breadcrumb-item>
          <a-breadcrumb-item>{{ $t('ke-hu-an-li') }}</a-breadcrumb-item>
        </a-breadcrumb>
      </template>
      <template #content>
        <div class="mx-auto banner-title text-center mt-[94px]">
          <div class="text-[38px] font-bold truncate">{{ config?.title }}</div>
          <div class="text-16 mt-[20px] truncate">
            {{ config?.subtitle }}
          </div>
        </div>
      </template>
    </Banner>
    <div class="mx-auto w-[1200px]">
      <div class="grid grid-cols-4 pt-[40px] gap-[15px]">
        <template v-for="(item, index) in data?.data?.results" :key="item.id">
          <ContentBaseCard
            v-if="openMore ? true : index < MAX_COUNT"
            :data="item"
            :link="{
              name: PageKey.CASE_DETAIL,
              params: {
                id: item.id,
              },
            }"
            @go="goLink"
          >
            <template #other>
              <div class="h-[40px] flex-y-center logo mt-[15px]">
                <Resource
                  :src="item?.logo_image_url"
                  class="max-w-[128px] object-cover max-h-[40px]"
                ></Resource>
              </div>
            </template>
          </ContentBaseCard>
        </template>
      </div>
      <a-spin :spinning="status === 'pending'"></a-spin>
      <div
        v-if="(data?.data?.results.length || 0) > MAX_COUNT"
        class="see-more"
        @click="toggleShow"
      >
        <template v-if="!openMore">
          <span>{{ $t('cha-kan-geng-duo') }}</span>
          <iconpark-icon name="arrowdown"></iconpark-icon>
        </template>
        <template v-else>
          <span>{{ $t('shou-qi') }}</span>
          <iconpark-icon class="rotate-180" name="arrowdown"></iconpark-icon>
        </template>
      </div>
      <Bottom
        class="mt-[42px]"
        :title="$t('cheng-wei-he-zuo-huo-ban')"
        :desc="
          $t(
            'wo-men-qi-dai-he-geng-duo-de-you-xiu-tuan-dui-gong-tong-tan-suo-aigc3d-shi-pin-chuang-zuo-zhi-dian'
          )
        "
      />
    </div>
  </div>
</template>

<script lang="ts" setup>
import Banner from '~/features/publicize/banner.vue'
import Bottom from '~/features/publicize/bottom.vue'
import { getCaseInfo, getCaseList } from '~/api'
import type { IGetCaseInfo, IGetCaseItem } from '~/api/interface/publicize'
import { useSeoData } from '~/hooks/useSeo'
import { PageKey } from '~/constants/page'

const separator = h('iconpark-icon', { name: 'breadcrumb-separator', size: 10 })

const seoData = useSeoData()
const route = useRoute()

const config = ref<IGetCaseInfo>()
// const list = ref<IGetCaseItem[]>([])
// const loading = ref(false)
const homeRoute = useHomeRoute()

provideResourceLocation({
  source: SOURCE.CASE,
})

const openMore = ref(false)
const MAX_COUNT = 8
const pagination = ref({
  page: 1,
  page_size: 100,
})

const goLink = (item: IGetCaseItem) => {
  trackEvent(TRACK_EVENT.CLICK_CASE_DETAIL, {
    source: `${PUBLICIZE_FORM.OTHER}-${item.title}`,
    customer: item.customer_name,
    position: '客户案例集合页',
  })
  // const router = useRouter()
  // router.push({
  //   name: PageKey.CASE_DETAIL,
  //   params: {
  //     id: item.id,
  //   },
  // })
}

const toggleShow = () => {
  openMore.value = !openMore.value
}

const fetchInfo = async () => {
  const res = await getCaseInfo()

  if (!res.code && res.data) {
    config.value = res.data
    seoData.value.push({
      description: res.data.seo_description,
      keywords: res.data.seo_keywords,
      title: res.data.seo_title,
      path: route.path,
    })
  }
}

useAsyncData(fetchInfo)
const { data, status } = useAsyncData(() => getCaseList(pagination.value))
</script>

<style lang="scss" scoped>
.banner-title {
  color: var(--purple-10);
}
.industry {
  .test-btn {
    @apply w-[278px]  rounded-[20px] h-[44px] text-[16px];
    box-shadow: 0px 13px 34px 0px rgba(102, 97, 194, 0.23);
  }
  .see-more {
    @apply w-[180px] h-[36px] gap-[5px] mt-[40px] cursor-pointer text-font-1 bg-purple-1 rounded-full mx-auto flex-y-center justify-center;
  }
}
</style>
